export default "__VITE_PUBLIC_ASSET__3fdb2646__"